import { ActivatedRouteSnapshot, CanActivate, CanLoad, Route, Router, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';
import { ClientApiService } from '../api/api.service';
import { AuthService } from '../auth/auth.service';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';


@Injectable()
export class AuthGuard implements CanActivate, CanLoad {

  constructor(
    private auth: AuthService,
    private router: Router,
    private apiClient: ClientApiService,
    private notify: NotificationsService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.userIsAuth();
  }
  canLoad(route: Route): Observable<boolean> | Promise<boolean> | boolean {
    return this.userIsAuth();
  }
  userIsAuth(): Observable<boolean> | Promise<boolean> | boolean {

    const userProfile = this.auth.userProfile;

    if (!userProfile || !this.auth.userPermissions) {
      this.auth.logout();
      this.router.navigate(['/login']);
      return false;
    }

    if (this.auth.isAuthenticated()) {
      return true;
    }
    return this.apiClient.get('token')
    .pipe(
      map(profile => {
        this.auth.userProfile = profile;
        return true;
      }),
      catchError(error => {
        console.error(error.message);
        this.notify.error('Error', error.message);
        return of(false);
      })
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/core/guards/auth-guard.ts